<template>
    <v-app style="width: 100%;">
        <router-view></router-view>
        <div class="dl-required-form" v-if="display_required_form">
            <v-img width="70" :src="settings_request_icon"></v-img>
            <span class="span-welcome">{{ settings_request_text }}</span>
            <input
                    ref="txt_required_name"
                    class="input-name"
                    :placeholder="settings_request_placeholder"
                    v-model="username"
                    @keypress.enter="enter_users_name"
                    autocomplete="off"
                    maxlength="255"
            />
            <div class="btn-container">
                <div class="extra-information" v-if="(extra_infomarion && extra_infomarion.length > 0)">
                  <div  :key="index" v-for="(info, index) in extra_infomarion">
                    <input
                        :ref="'txt_' + info.variable"
                        class="input-extra-info"
                        :placeholder="info.label"
                        v-model="info.value"
                        autocomplete="off"
                        maxlength="100"
                        @blur="validate_data(info)"
                    />
                  </div>

                </div>
                <v-btn class="submit-name" rounded color="primary" @click="enter_users_name">{{ settings_request_button }}</v-btn>
            </div>
        </div>
        <v-dialog v-model="display_reconnect_form" persistent max-width="390">
            <v-card>
                <v-card-text class="pa-1">
                    <v-btn color="primary" style="width: 100%;" text @click="reconnectSocket">Reconnect</v-btn>
                </v-card-text>
            </v-card>
        </v-dialog>
        <v-dialog v-model="display_connecting_form" persistent max-width="390">
            <v-card>
                <v-card-text class="pa-1 dl-connecting">
                    <span>CONNECTING</span>
                    <div class="lds-facebook">
                        <div></div>
                        <div></div>
                        <div></div>
                    </div>
                </v-card-text>
            </v-card>
        </v-dialog>

        <v-dialog id="dl_display_webview" v-model="display_webview" persistent max-width="600">
          <v-card style="width: 100%; height: 100%; overflow: hidden;">
            <v-toolbar dark color="primary" style="height:35px;">
              <v-toolbar-title>{{ webview_header }}</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-btn icon dark small @click="display_webview = false">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-toolbar>
            <iframe id="ifr_display_webview" :name="ifrm_webview_name" ref="ifr_display_webview" :src="webview_url" style="width: 100%; height: calc(100% - 35px); border: 0;"></iframe>
          </v-card>
        </v-dialog>

        <a id="ctr_link" href="#" target="_blank" hidden></a>
        <a id="ctr_phone" href="#" hidden target="_blank"></a>
        <input id="ctr_upload_file" hidden type="file" name="upload_file"/>
    </v-app>
</template>

<script>
/* eslint-disable */
import $ from 'jquery'
import handlerMessage from './business/handler_messages'
import handlerData from './business/handler_data'

var socketCluster = require('socketcluster-client')
var md5           = require('md5')

export default {
    name      : 'App',
    components: {},
    mounted() {
        // Custom Styles
        this.getCustomUI()

        // Custom settings control request info
        console.log(this.$route);
        if (this.getUrlParam('setting_request_info_logo') && this.getUrlParam('setting_request_info_logo') !== '') {
            this.settings_request_icon = this.getUrlParam('setting_request_info_logo')
        } else {
            this.settings_request_icon = this.baseUrl + '/img/robot.png'
        }
        if (this.getUrlParam('setting_request_info_text') && this.getUrlParam('setting_request_info_text') !== '') {
            this.settings_request_text = this.getUrlParam('setting_request_info_text')
        } else {
            this.settings_request_text = 'Please input your name'
        }
        if (this.getUrlParam('setting_request_info_placeholder') && this.getUrlParam('setting_request_info_placeholder') !== '') {
            this.settings_request_placeholder = this.getUrlParam('setting_request_info_placeholder')
        } else {
          this.settings_request_placeholder = ''
        }
        console.log(this.getUrlParam('setting_request_info_button'))
        if (this.getUrlParam('setting_request_info_button') && this.getUrlParam('setting_request_info_button') !== '') {
            this.settings_request_button = this.getUrlParam('setting_request_info_button')
        } else {
            this.settings_request_button = 'OKAY'
        }

        this.fptaiEndpoint         = this.getUrlParam('scendpoint') || process.env.VUE_APP_SOCKETCLUSTER_HOST
        this.botCode               = this.getUrlParam('botcode')
        this.$store.state.botCode  = this.botCode
        let chat_client            = {
            name : '',
            id   : '',
            token: ''
        }
        // UPDATE 2019/10/14 - chat_client format: name, id, token
        this.$store.state.componentsMainApp = this
        this.$store.state.bot_icon = this.getUrlParam('iconbot')
        let customize_sender_name  = this.getUrlParam('sendername')
        let subChannel = this.getUrlParam('subchannel')
        if (subChannel && subChannel !== '') {
            this.$store.state.subChannel = subChannel
        }

        //
        // console.log(this.getUrlParam('extra_info'))
        try{
          let extra_config = this.getUrlParam('extra_info');
          this.extra_infomarion = JSON.parse(extra_config);
        } catch (e) {
        }

        // Update 2021-08-12 Update sender_id, sender_token from Client
        this.use_client_sender_info = false;
        if (this.getUrlParam('use_client_sender_info') && this.getUrlParam('use_client_sender_info') == '1') {
          this.use_client_sender_info = true;
          chat_client.name = customize_sender_name;
          chat_client.id = this.getUrlParam('sender_id');
          chat_client.token = this.getUrlParam('sender_token');

          // // check allow send start message
          // let allow_send_start_msg = false;
          // if (localStorage.getItem('fptai_livechat_client_customer_' + this.botCode)) {
          //   let customer_client = JSON.parse(localStorage.getItem('fptai_livechat_client_customer_' + this.botCode));
          //   if (customer_client.id !== chat_client.id) {
          //     allow_send_start_msg = true;
          //   }
          // }

          // save user info to localstorage
          let data_local_client = {
            id: chat_client.id
          }
          localStorage.setItem(
              'fptai_livechat_client_customer_' + this.botCode,
              JSON.stringify(data_local_client)
          )
          this.$store.state.customSender = true;

          // #DOING: set variable
          let object_payload = {
            set_attributes: {},
          };
          console.log(this.extra_infomarion);
          if (this.extra_infomarion) {
            for (let i = 0; i < this.extra_infomarion.length; i++) {
              // if (this.extra_infomarion[i].type === 'number' && this.extra_infomarion[i].value === '') {
              //   if (this.extra_infomarion[i].require) {
              //     let control_ref = "txt_" + this.extra_infomarion[i].variable
              //     this.$refs[control_ref][0].focus()
              //     check_valid = false
              //     break;
              //   }
              // }

              if (this.extra_infomarion[i].variable) {
                object_payload.set_attributes[this.extra_infomarion[i].variable] =
                    this.extra_infomarion[i].value;
              }
            }
          }

          // if (!check_valid) {
          //   return false;
          // }

          this.data_payload = handlerData.b64EncodeUnicode(
            JSON.stringify(object_payload)
          );
          console.log(this.data_payload);
          this.$store.state.startPayload = this.data_payload;
          // #END: set variable

          this.connectSocket(chat_client);
          setTimeout(function () {
            $('#txt_input_message')[0].focus()
          }, 500);
        }

        if (!this.use_client_sender_info) {
          // check client id in local store
          if (localStorage.getItem('fptai_livechat_client_' + this.botCode)) {
            chat_client = JSON.parse(
                localStorage.getItem('fptai_livechat_client_' + this.botCode)
            )
            this.connectSocket(chat_client, false, true)
            setTimeout(function () {
              $('#txt_input_message')[0].focus()
            }, 500)
          } else if (customize_sender_name && customize_sender_name.trim() !== '') {
            // sender config name
            let chat_client = {
              name : customize_sender_name.trim(),
              id   : md5(handlerData.guid() + this.botCode),
              token: ''
            }
            // save users information to localstorage
            localStorage.setItem(
                'fptai_livechat_client_' + this.botCode,
                JSON.stringify(chat_client)
            )
            this.display_required_form   = false
            this.display_connecting_form = true
            this.connectSocket(chat_client, true, true)
            setTimeout(function () {
              $('#txt_input_message')[0].focus()
            }, 500)

          } else {
            // request user information
            this.display_required_form   = true
            this.display_connecting_form = false
            setTimeout(
                function () {
                  this.$refs.txt_required_name.focus()
                }.bind(this),
                500
            )
          }
        }

    },

    data: () => ({
        // display form input user information
        display_required_form  : false,
        fptaiEndpoint          : '',
        botCode                : '',
        username               : '',
        display_reconnect_form : false,
        display_connecting_form: true,
        display_webview: false,
        webview_header: "",
        webview_url: "",
        ifrm_webview_name: Date.now(),
        // -- for settings
        settings_request_icon: '',
        settings_request_text: '',
        settings_request_placeholder: '',
        settings_request_button: '',

        extra_infomarion: [],
        data_payload: '',
        use_client_sender_info: false,

    }),

    methods : {
        getUrlParam(name, url) {
            if (!url) url = location.href
            name        = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]')
            let regexS  = '[\\?&]' + name + '=([^&#]*)'
            let regex   = new RegExp(regexS)
            let results = regex.exec(url)
            return results == null ? null : decodeURIComponent(results[1])
        },

        getCustomUI() {
            let styles = {
                original         : {},
                scrollBg         : '',
                botIcon          : '',
                msgLeftBg        : '',
                msgLeftColor     : '',
                msgRightBg       : '',
                msgRightColor    : '',
                textSize         : '',
                titleSize        : '',
                titleColor       : '',
                titleBg          : '',
                titleHeight      : '',
                subTitleSize     : '',
                subTitleColor    : '',
                buttonSize       : '',
                buttonColor      : '',
                buttonBorderColor: '',
                buttonBg         : '',
                buttonHeight     : '',
                imageBg          : '',
                formBg           : '',
                formColor        : '',
                formBorderColor  : '',
                sendBtnColor     : ''
            }
            let s      = this.getUrlParam('styles')
            if (s) {
                s                        = JSON.parse(s)
                styles.original          = s
                styles.scrollBg          = s.scrollBg ? {background: s.scrollBg} : ''
                styles.botIcon           = s.botIcon ? s.botIcon : ''
                styles.msgLeftBg         = s.msgLeftBg ? {background: s.msgLeftBg} : ''
                styles.msgLeftColor      = s.msgLeftColor ? {color: s.msgLeftColor} : ''
                styles.msgRightBg        = s.msgRightBg ? {background: s.msgRightBg} : ''
                styles.msgRightColor     = s.msgRightColor ? {color: s.msgRightColor} : ''
                styles.textSize          = s.textSize ? {fontSize: s.textSize} : ''
                styles.titleSize         = s.titleSize ? {fontSize: s.titleSize} : ''
                styles.titleColor        = s.titleColor ? {color: s.titleColor} : ''
                styles.titleBg           = s.titleBg ? {background: s.titleBg} : ''
                styles.titleHeight       = s.titleHeight ? {height: s.titleHeight} : ''
                styles.subTitleSize      = s.subTitleSize ? {fontSize: s.subTitleSize} : ''
                styles.subTitleColor     = s.subTitleColor ? {color: s.subTitleColor} : ''
                styles.buttonSize        = s.buttonSize ? {fontSize: s.buttonSize} : ''
                styles.buttonColor       = s.buttonColor ? {color: s.buttonColor} : ''
                styles.buttonBorderColor = s.buttonBorderColor ? {borderColor: s.buttonBorderColor} : ''
                styles.buttonBg          = s.buttonBg ? {background: s.buttonBg} : ''
                styles.buttonHeight      = s.buttonHeight ? {height: s.buttonHeight} : ''
                styles.imageBg           = s.imageBg ? {background: s.imageBg} : ''
                styles.formBg            = s.formBg ? {background: s.formBg} : ''
                styles.formColor         = s.formColor ? {color: s.formColor} : ''
                styles.formBorderColor   = s.formBorderColor ? {borderTop: '1px solid ' + s.formBorderColor} : ''
                styles.sendBtnColor      = s.sendBtnColor ? {color: s.sendBtnColor} : ''
            }
            this.$store.dispatch(this.$ActionTypes.SET_CUSTOM_STYLES, styles)
        },

        reconnectSocket() {
            this.$router.go(0)
        },

        connectSocket(objClient, sendStartMsg = false, allowReConnect = true) {
            console.log('connectSocket - ' + allowReConnect)
            // console.log(objClient);
            this.$store.state.clientId    = objClient.id
            this.$store.state.clientName  = objClient.name
            this.$store.state.clientToken = objClient.token

            if (!this.$store.state.scClient) {
                // connect socket cluster
                // console.log(process.env.VUE_APP_SOCKET_SECURE);
                var sc_sercure             = process.env.VUE_APP_SOCKET_SECURE === 'secure'
              console.log(process.env.VUE_APP_SOCKET_SECURE,"------------------------------------")
                var option                 = {
                    host  : this.fptaiEndpoint,
                    secure: sc_sercure,
                    path  : '/ws/'
                }
                // console.log(option);
                this.$store.state.scClient = socketCluster.connect(option)
            }

            // send authorize request
            let data_send_request_authorize = {
                sender_id  : objClient.id,
                token      : objClient.token,
                sender_name: objClient.name,
                bot_code   : this.botCode,
                sub_channel: this.$store.state.subChannel
            }

            let _this = this

            this.$store.state.scClient.emit(
                'sender_request_authenticate',
                data_send_request_authorize,
                async function (err, data) {
                    // console.log(err);
                    // console.log(data);
                    if (err) {
                        // console.log(err);
                        // check if timeout error
                        if (err['name'] === 'TimeoutError' || err['name'] === 'BadConnectionError') {
                            // re-connect socket
                            _this.connectSocket(objClient, sendStartMsg, allowReConnect)
                        } else {
                            // authen failed
                            // create new client id to reconnect
                            let chat_client = {
                                name : objClient.name,
                                id   : md5(handlerData.guid() + _this.botCode),
                                token: ''
                            }

                            // save users information to localstorage
                            console.log('>>>>>>>>> CHANGE CLIENT LOCALSTORE >>>>>>>>>')
                            // console.log(chat_client);
                            localStorage.setItem(
                                'fptai_livechat_client_' + _this.botCode,
                                JSON.stringify(chat_client)
                            )

                            if (allowReConnect) {
                                // for error in server but client is reconnect forever
                                _this.connectSocket(chat_client, true, false)
                            }
                        }
                    } else {
                        // save token to localstore
                        let chat_client = {
                            name : objClient.name,
                            id   : objClient.id,
                            token: data.sender_token
                        }

                        // save users information to localstorage
                      console.log('use_client_sender_info - ' + _this.use_client_sender_info)
                      if (_this.use_client_sender_info) {
                        localStorage.setItem(
                            'fptai_livechat_client_customer_' + _this.botCode,
                            JSON.stringify({id: objClient.id})
                        )
                      } else {
                        localStorage.setItem(
                            'fptai_livechat_client_' + _this.botCode,
                            JSON.stringify(chat_client)
                        )
                      }


                        // save User Token to store
                        _this.$store.state.clientToken = chat_client.token

                        // create and subscribe channel
                        let scb_channel =
                                md5(objClient.id + '.' + _this.botCode) +
                                '@' +
                                _this.botCode +
                                '/livechat'

                        _this.$store.state.scClient.on('error', function (err) {
                            console.log(err)
                            throw 'Socket error - ' + err
                        })

                        _this.$store.state.scClient.on('disconnect', function () {
                            console.log('Socket disconnect')
                            _this.display_reconnect_form = true
                        })

                        _this.$store.state.scSubscribeChannel = _this.$store.state.scClient.subscribe(
                            scb_channel
                        )

                        _this.display_connecting_form = false

                        _this.$nextTick(() => {
                            _this.$store.state.scSubscribeChannel.watch(data => {
                                _this.$store.state.componentsMainChatBox.handler_messages(data)
                            })
                        })

                        // send message get started
                        // console.log("send_start_message - " + sendStartMsg);
                        if (sendStartMsg) {
                            handlerMessage.send_start_message(_this.$store.state.subChannel, _this.data_payload)
                        }

                        setTimeout(function () {
                            $('#txt_input_message')[0].focus()
                        }, 500)
                    }
                }
            )

            let themes = this.getUrlParam('themes')
            let linkThemes
            if (themes && themes !== '') {
                switch (themes) {
                    case 'red':
                        linkThemes      = document.createElement('link')
                        linkThemes.id   = 'import_link_linkThemes_fpt_ai'
                        linkThemes.rel  = 'stylesheet'
                        linkThemes.href = 'static/style-red.css'
                        $('head').append(linkThemes)
                        break
                    case 'blue':
                        linkThemes      = document.createElement('link')
                        linkThemes.id   = 'import_link_linkThemes_fpt_ai'
                        linkThemes.rel  = 'stylesheet'
                        linkThemes.href = 'static/style-blue.css'
                        $('head').append(linkThemes)
                        break
                    default:
                        linkThemes      = document.createElement('link')
                        linkThemes.id   = 'import_link_linkThemes_fpt_ai'
                        linkThemes.rel  = 'stylesheet'
                        linkThemes.href = 'static/style-' + themes + '.css'
                        $('head').append(linkThemes)
                        break
                }
            }

            // console.log(this.$store.state.scClient);
        },

        enter_users_name() {
            if (this.username.trim() === '') {
                this.$refs.txt_required_name.focus()
                return false
            }

            let chat_client = {
                name : this.username.trim(),
                id   : md5(handlerData.guid() + this.botCode),
                token: ''
            }

            // handler extra data
            if (this.extra_infomarion && this.extra_infomarion.length > 0) {
              let check_valid = true;
              let object_payload = {
                "set_attributes": {}
              }
              for (let i = 0; i < this.extra_infomarion.length; i++) {

                if (this.extra_infomarion[i].type === 'number' && this.extra_infomarion[i].value === '') {
                  if (this.extra_infomarion[i].require) {
                    let control_ref = "txt_" + this.extra_infomarion[i].variable
                    this.$refs[control_ref][0].focus()
                    check_valid = false
                    break;
                  }
                }

                if (this.extra_infomarion[i].variable) {
                  object_payload.set_attributes[this.extra_infomarion[i].variable] = this.extra_infomarion[i].value;
                }
              }
              if (!check_valid) {
                return false;
              }

              this.data_payload = handlerData.b64EncodeUnicode(JSON.stringify(object_payload));
            }


          // save users information to localstorage
            localStorage.setItem(
                'fptai_livechat_client_' + this.botCode,
                JSON.stringify(chat_client)
            )
            this.display_required_form   = false
            this.display_connecting_form = true
            this.connectSocket(chat_client, true, true)

        },
        open_webview (title, url) {
          this.display_webview = true;
          if (this.$refs.ifr_display_webview) {
            this.$refs.ifr_display_webview.contentWindow.location.replace('');
          }
          this.$nextTick(() => {
            // this.webview_url = url;
            this.$refs.ifr_display_webview.parentNode.parentNode.parentNode.id = "dl_display_webview"
            this.$refs.ifr_display_webview.contentWindow.location.replace(url);
          });
        },
        close_webview() {
          this.display_webview = false;
        },
        // extra information
        validate_data(item) {
          if (item.type === 'number') {
            // item.value = item.value.replaceAll(' ', '').replaceAll('.', '').replaceAll('-', '');
            item.value = item.value.replaceAll(/[^1234567890]/gi, '')
          } else {
            // default text
          }
        },
    },
    computed: {
        baseUrl() {
            return process.env.BASE_URL
        }
    }
}
</script>

<style>
    .v-application--wrap {
        width : 100% !important;
    }
    #dl_display_webview header {
      background-color: #fff !important;
      color: #424242;
    }
    #dl_display_webview header i {
      color: #424242;
    }
    #dl_display_webview header > div {
      height: 35px !important;
    }
    @media screen and (min-width: 768px) {
      #dl_display_webview div.v-dialog {
        height: 90%;
        max-height: 700px;
      }
    }
    @media screen and (max-width: 767px) {
      #dl_display_webview div.v-dialog {
        height: 100%;
        max-height: 100%;
        margin: 0;
        bottom: 0;
      }
    }

</style>

<style scoped>
    .dl-required-form {
      width            : 100%;
      height           : 100%;
      z-index          : 2000;
      position         : absolute;
      top              : 0;
      left             : 0;
      background-color : #fff;
    }
    .dl-required-form .v-image {
      position : absolute;
      top      : calc(20% - 30px);
      left     : calc(50% - 34px);
    }
    .dl-required-form .input-name {
      width         : 250px;
      height        : 40px;
      position      : absolute;
      top           : calc(60% - 85px);
      left          : calc(50% - 125px);
      text-align    : center;
      font-size     : 18px;
      outline       : none;
      margin        : 0 auto;
      background    : #f2f2f2;
      border-radius : 100px;
      padding       : 0 10px;
    }
    .dl-required-form .extra-information {
      position: relative;
      /* height: 50px; */
    }
    .dl-required-form .extra-information > div {
      margin-bottom: 10px;
    }
    .dl-required-form .input-extra-info {
      width         : 250px;
      height        : 40px;
      /* position      : absolute; */
      top           : calc(60% - 70px);
      left          : calc(50% - 125px);
      text-align    : center;
      font-size     : 18px;
      outline       : none;
      margin        : 0 auto;
      background    : #f2f2f2;
      border-radius : 100px;
      padding       : 0 10px;
    }
    .dl-required-form .btn-container {
      position   : absolute;
      top        : calc(60% - 33px);
      width      : 100%;
      text-align : center;
    }
    .dl-required-form .span-welcome {
      position    : absolute;
      top         : calc(40% - 30px);
      display     : block;
      width       : 100%;
      text-align  : center;
      font-family : Roboto;
      font-weight : bold;
      font-size   : 18px;
      line-height : 21px;
      color       : #878787;
    }
    .dl-connecting {
      text-align : center;
    }
    .dl-connecting span {
      display    : block;
      margin-top : 20px;
    }
    .dl-connecting .lds-facebook {
      display  : inline-block;
      position : relative;
      width    : 80px;
      height   : 80px;
    }
    .dl-connecting .lds-facebook div {
      display   : inline-block;
      position  : absolute;
      left      : 8px;
      width     : 16px;
      animation : lds-facebook 1.2s cubic-bezier(0, 0.5, 0.5, 1) infinite;
    }
    .dl-connecting .lds-facebook div:nth-child(1) {
      left            : 8px;
      animation-delay : -0.24s;
      background      : #6d9ccb;
    }
    .dl-connecting .lds-facebook div:nth-child(2) {
      left            : 32px;
      animation-delay : -0.12s;
      background      : #3aa4c9;
    }
    .dl-connecting .lds-facebook div:nth-child(3) {
      left            : 56px;
      animation-delay : 0;
      background      : #00afc8;
    }
    @keyframes lds-facebook {
      0% {
        top    : 8px;
        height : 64px;
      }
      50%,
      100% {
        top    : 24px;
        height : 32px;
      }
    }
</style>
